import { ChangeEvent, useState } from 'react';
import { Box, Button, CircularProgress, Dialog, DialogContent, DialogContentText, TextField, Typography, makeStyles } from '@material-ui/core';
import { useCreateCompany } from 'common/hooks/company/useCreateCompany';
import { useNotifier } from 'common/hooks/useNotifier';
import Message from 'common/models/Message';

const styles = {
    btnCancel: {
        border: '1px solid #2b333f',
        color: '#2b333f',
        '&:active': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:hover': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:focus': {
            backgroundColor: '1px solid #2b333f',
            boxShadow: 'none',
        },
        '&:disabled': {
            backgroundColor: '#eee !important',
            color: '#ccc !important',
        },
    },
    btnConfirm: {
        marginLeft: '5px',
    },
};

const useStyles = makeStyles(styles);

interface ICreateCompanyDialog {
    open: boolean;
    close: () => void;
}

export const CreateCompanyDialog = ({ open, close }: ICreateCompanyDialog) => {
    const classes = useStyles();
    const [name, setName] = useState('');
    const { createCompany } = useCreateCompany();
    const [isCreating, setIsCreating] = useState(false);
    const { notify } = useNotifier();

    const handleNameChange = (event: ChangeEvent<any>) => {
        setName(event.target.value);
    };

    const handelCreate = async () => {
        const trimmedName = name.trim();

        if (trimmedName === '') {
            return;
        }

        setIsCreating(true);

        try {
            await createCompany({ name: trimmedName });

            setName('');
            close();
        } catch (error) {
            console.error(error);
            notify(new Message({ title: `Unable to create company. ${error}`, type: 'error' }));
        }

        setIsCreating(false);
    };

    return (
        <Dialog open={open} aria-labelledby="form-dialog-title">
            <DialogContent>
                <DialogContentText color="primary">
                    <Box p={1} style={{ width: '25vw' }}>
                        <Typography variant="h6">Create Company</Typography>
                        <Box p={1}></Box>
                        <TextField fullWidth label="Name" variant="outlined" required={true} value={name} onChange={handleNameChange} />
                        <Box p={1}></Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', p: 1, m: 1, justifyContent: 'flex-end' }}>
                            <Button
                                variant="outlined"
                                size="medium"
                                color="secondary"
                                onClick={() => {
                                    setName('');
                                    close();
                                }}
                                disabled={isCreating}
                                className={classes.btnCancel}
                            >
                                Cancel
                            </Button>
                            <Button
                                autoFocus
                                variant="contained"
                                size="medium"
                                onClick={handelCreate}
                                disabled={isCreating}
                                className={classes.btnConfirm}
                            >
                                Create
                                {isCreating ? (
                                    <>
                                        <Box sx={{ ml: 1, mr: 1 }}>
                                            <CircularProgress size={'0.8rem'} color="inherit" />
                                        </Box>
                                    </>
                                ) : (
                                    <></>
                                )}
                            </Button>
                        </Box>
                    </Box>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};
